module.exports = __webpack_public_path__ + "AdobeStock_285202108_panel_iconcolors2.svg?2d09229f594c7ab33e645fb324f7ef21";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_285202108_panel_iconcolors2.svg
// module id = 331
// module chunks = 0